import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";
import { TravelInsuranceRange, GetSoQuery } from "../types/types";
import { useGetSo } from "../queries/useGetSo.query";

const CHANGE_TRAVEL_INSURANCE_RANGE_MUTATION = gql(`
  mutation ChangeTravelInsuranceRange($id: String!, $travelInsuranceRange: TravelInsuranceRange!) {
      changeTravelInsuranceRange(id: $id, travelInsuranceRange: $travelInsuranceRange)
  }
`);

  export function useChangeTravelInsuranceRange() {
  const { soId } = useGeneralSoContext();
  const { refetch } = useGetSo();
  const [mutation, info] = useMutation(CHANGE_TRAVEL_INSURANCE_RANGE_MUTATION, {
    update: (cache, { data }, { variables }) => {
      if (data?.changeTravelInsuranceRange && soId && variables?.travelInsuranceRange) {
        try {
          const fullData = cache.readQuery<GetSoQuery>({
            query: gql`
              query GetSo($id: String!) {
                getSo(id: $id) {
                  _id
                  soNumber
                  status
                  productTypeSpecific {
                    travelData {
                      insuranceRange
                    }
                  }
                }
              }
            `,
            variables: { id: soId }
          });
          
          if (fullData?.getSo) {
            const actualCacheId = cache.identify({ __typename: 'GetSoDto', _id: fullData.getSo._id });
            
            cache.modify({
              id: actualCacheId,
              fields: {
                productTypeSpecific(existing) {
                  if (existing && existing.travelData) {
                    return {
                      ...existing,
                      travelData: {
                        ...existing.travelData,
                        insuranceRange: variables.travelInsuranceRange
                      }
                    };
                  }
                  return existing;
                }
              }
            });
          }
          } catch (error) {
            refetch();
          }
      }
    }
  });
  
  const changeTravelInsuranceRange = async (travelInsuranceRange: TravelInsuranceRange) => {
    const { data } = await mutation({
      variables: { id: soId, travelInsuranceRange },
    });
    return data;
  };
  return [changeTravelInsuranceRange, info] as const;
}
